import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { ProductComparisonProductCodeRequestDTO } from "./dto";

export const pinProduct = async (productCode: string): Promise<void> => {
  const url = occUrl("/product-comparison/pin-product");

  const response = await occFetch(url, {
    method: "POST",
    cache: "no-cache",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ productCode } satisfies ProductComparisonProductCodeRequestDTO),
  });

  if (!response.ok) {
    throw new Error(`Failed to pin product: ${response.status}`);
  }
};

export const unPinProduct = async (productCode: string): Promise<void> => {
  const url = occUrl("/product-comparison/unpin-product");

  const response = await occFetch(url, {
    method: "POST",
    cache: "no-cache",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ productCode } satisfies ProductComparisonProductCodeRequestDTO),
  });

  if (!response.ok) {
    throw new Error(`Failed to pin product: ${response.status}`);
  }
};
